export default "__VITE_ASSET__DB8cmy5K__"